import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Home } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const UnauthorizedPage = () => {
    const { currentUser, logout } = useAuth();

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="flex justify-center">
                    <Shield className="h-16 w-16 text-red-600" />
                </div>
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Access Denied</h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                    You don't have permission to access this resource
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
                        <div className="flex">
                            <div className="ml-3">
                                <p className="text-sm text-red-700">
                                    This page requires elevated permissions that your account ({currentUser?.email || 'Unknown'}) doesn't have.
                                </p>
                                <p className="text-sm text-red-700 mt-2">
                                    If you believe this is an error, please contact your administrator.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-center space-x-4">
                        <Link
                            to="/"
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <Home className="h-4 w-4 mr-2" />
                            Go to Dashboard
                        </Link>
                        <button
                            onClick={logout}
                            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Sign Out
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnauthorizedPage;